<template>
    <img :src="bannerInfo.thumbnail | resizeThumbnail({width:750, height: 420, quality: 75, multiply: 3})" alt=""
         class="multi-banner-item">
</template>

<script>
import { resizeThumbnail } from '@/common/image.filter'

export default {
  name: 'MultiBannerItem',
  props: ['bannerInfo'],
  filters: {
    resizeThumbnail
  },
  methods: {
    // clickEvent (bannerInfo) {
    //   console.log('image')
    //   const { onNavigationEvent } = getEventListByType(bannerInfo.event_list)
    //   let moveLocation = onNavigationEvent.url.replace('www.pooq.co.kr', '').replace('.html', '')
    //   this.$router.push(moveLocation)
    // }
  }
}
</script>

<style scoped>
  .multi-banner-item {
    width: 100%;
  }
</style>
